import React, { useState, useEffect } from 'react';
import { api } from '../../api/nocode';
import Card from '../../components/ui/Card';
import SafeIcon from '../../common/SafeIcon';

export default function AdminDashboard() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await api.get('users_gwacamp');
        const data = Array.isArray(res) ? res : res.data || [];
        setUsers(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const totalReg = users.length;
  const allAccess = users.filter(u => u.pass_type === 'allaccess').length;

  const stats = [
    { label: 'Total Registrations', value: totalReg, icon: 'Users', color: 'text-blue-500' },
    { label: 'All-Access Passes', value: allAccess, icon: 'Award', color: 'text-amber' },
  ];

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Admin Overview</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {stats.map((stat, i) => (
          <Card key={i} className="flex items-center gap-4">
            <div className={`p-3 rounded-full bg-gray-50 ${stat.color}`}>
              <SafeIcon name={stat.icon} className="text-2xl" />
            </div>
            <div>
              <p className="text-sm text-gray-500 font-medium">{stat.label}</p>
              <p className="text-2xl font-bold text-gray-800">{stat.value}</p>
            </div>
          </Card>
        ))}
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <h2 className="text-lg font-bold text-gray-800 mb-4">Registration Trend</h2>
          <div className="h-64 bg-gray-50 rounded flex items-center justify-center text-gray-400 border border-dashed border-gray-200">
            Chart coming soon
          </div>
        </Card>
        <Card>
          <h2 className="text-lg font-bold text-gray-800 mb-4">Recent Registrations</h2>
          <div className="space-y-4">
            {users.slice(0, 5).map(u => (
              <div key={u.id} className="flex items-center gap-3 text-sm border-b pb-2">
                <div className={`w-2 h-2 rounded-full ${u.pass_type === 'allaccess' ? 'bg-amber' : 'bg-gray-300'}`}></div>
                <span className="font-medium">{u.name}</span> registered
                <span className="text-xs ml-auto uppercase text-gray-500">{u.pass_type}</span>
              </div>
            ))}
            {users.length === 0 && !loading && (
              <div className="text-gray-500 text-sm">No registrations yet.</div>
            )}
            {loading && (
              <div className="text-gray-500 text-sm">Loading...</div>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}